export default function GetNoIndexImages() {
    const renderHandler = event => {
        const context = event ? event.detail : document;
        const images = context.querySelectorAll('[data-img]');
        images.forEach($img => {
            const src = $img.getAttribute('data-img');
            const alt = $img.getAttribute('data-img-alt');
            const image = document.createElement('img');
            image.setAttribute('data-src', src);
            image.setAttribute('alt', alt);
            $img.appendChild(image);
        });
    };

    renderHandler();

    MNTK.emit('updateLazyLoadImages');
    document.addEventListener('renderNoIndexImages', renderHandler);
}
